<template>
    <div>
    
        <div class="columns">       
            <div class="column is-10 is-offset-1">

                <div class='box mt-6'>
                    <div class="block title">
                        Python API token: {{ auth_token }}
                    </div>

                    <div class="block">
                        <b-button  type="is-primary" @click="copyURL">{{copy_button_text}}</b-button>
                    </div>
            
                    <b-notification
                        auto-close 
                        type="is-success"
                        duration="5000"
                        v-if="auth_token_copied_to_clipboard"
                        aria-close-label="Close notification">
                        Copied to clipboard
                    </b-notification>

                    <h1>{{ info_text }}</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'

    export default {
        mixins: [GetAxiosAuthConfig],
        data() {
            return {
                auth_token: '',
                auth_token_copied_to_clipboard: false,
                copy_button_text: 'Copy to Clipoard',
                info_text: ''
            }
        },
        mounted() {
            this.auth_token = axios_auth_config.headers.Authorization.split(" ")[1]
        },
        methods: {
            async copyURL() {
                try {
                    await navigator.clipboard.writeText(this.auth_token);
                    this.auth_token_copied_to_clipboard = true
                    this.info_text = 'Now you can close this page!'
                    this.copy_button_text = 'Copied!'
                } catch($e) {
                    alert('Copying to clipboard failed');
                }
            },
        }
    }

</script>

<style scoped lang="scss">
</style>